// src/components/Header.jsx (con shadow en el borde inferior)
import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const Header = ({ 
  title, 
  showCatalogButton = true, // true = desde ListView (List activo), false = desde CatalogView (Catalog activo)
  onRefresh,
  onSettings 
}) => {
  const { user, logout } = useAuth();

  const handleListClick = () => {
    window.location.hash = '#list';
  };

  const handleCatalogClick = () => {
    window.location.hash = '#catalog';
  };

  const isListActive = showCatalogButton;     // showCatalogButton=true → List activo
  const isCatalogActive = !showCatalogButton; // showCatalogButton=false → Catalog activo

  const handleLogout = async () => {
    await logout();
  };

  return (
    <div className="bg-white shadow-sm border-b border-gray-200 pl-4 pr-3 py-[12px] shadow">
      <div className="flex justify-between items-center">
        {/* LADO IZQUIERDO: Tabs de navegación */}
        <div className="flex items-center space-x-1">
          {/* Tab List */}
          <button 
            onClick={handleListClick}
            className={`px-3 py-1.5 rounded-lg flex items-center space-x-2 transition-colors ${
              isListActive 
                ? 'bg-purple-600 text-white' 
                : 'bg-white text-gray-700 hover:bg-gray-200'
            }`}
          >
            <i className="fas fa-shopping-cart"></i>
            <span className="font-medium">List</span>
          </button>

          {/* Tab Catalog */}
          <button 
            onClick={handleCatalogClick}
            className={`px-3 py-1.5 rounded-lg flex items-center space-x-2 transition-colors ${
              isCatalogActive 
                ? 'bg-purple-600 text-white' 
                : 'bg-white text-gray-700 hover:bg-gray-200'
            }`}
          >
            <i className="fas fa-book"></i>
            <span className="font-medium">Catalog</span>
          </button>
        </div>

        {/* LADO DERECHO: Iconos Refresh y Menu */}
        <div className="flex items-center space-x-2">
          {/* Refresh */}
          <button 
            onClick={onRefresh}
            className="flex flex-col items-center text-gray-600"
          >
            <div className="w-9 h-9 rounded-full flex items-center justify-center">
              <i className="fas fa-sync-alt text-xl"></i>
            </div>
          </button>

          {user?.username && (
            <span className="hidden sm:inline text-xs text-gray-500 font-medium max-w-[90px] truncate">
              {user.username}
            </span>
          )}

          <button
            onClick={handleLogout}
            className="w-9 h-9 rounded-full flex items-center justify-center text-gray-500 hover:bg-gray-100 transition-colors"
            aria-label="Logout"
            title="Logout"
          >
            <i className="fas fa-sign-out-alt text-lg"></i>
          </button>

          {/* Version */}
          <button 
            onClick={onSettings}
            className="flex flex-col items-center text-gray-600"
          >
            <div className="w-9 h-9 rounded-full flex items-center justify-center text-gray-400">
              {/* <i className="fas fa-bars text-xl"></i> */}
              v2.4
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;